export default "__VITE_ASSET__BdvhSKm3__"